import React, { useState, useRef } from 'react';
import { RiFileEditLine as EditLine, RiFileDownloadLine as DownloadLine } from 'react-icons/ri';
import {
  DropdownItem, Wrapper, Dropdown
} from 'Screens/Contextualization/Manage/components/CreateActions/styled';
import AddButton from 'shared/ui/AddButton';
import { useDispatch, useSelector } from 'react-redux';
import { showCreateEditModal, showImportModal } from 'store/Credentials/actions';
import useClickOutside from 'Hooks/useClickOutside';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_CREDENTIALS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { useIntl } from 'react-intl';

const AddCredentialButton = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const dropdownRef = useRef();
  const [showDropdown, setShowDropdown] = useState(false);
  const allowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_CREDENTIALS, PERMISSION_TYPES.CREATE));
  useClickOutside(dropdownRef, () => setShowDropdown(false));

  const handleDropdown = () => {
    if (allowedByRole) setShowDropdown(!showDropdown);
  };

  const handleShow = () => {
    dispatch(showCreateEditModal(true, {}));
    setShowDropdown(false);
  };

  const handleClickImport = () => {
    dispatch(showImportModal(true));
    setShowDropdown(false);
  };

  return (
    <Wrapper ref={ dropdownRef }>
      <AddButton onClick={ handleDropdown } disabled={ !allowedByRole }>
        {intl.formatMessage({ id: 'common.button.add.credentials' }) }
      </AddButton>
      {showDropdown && (
      <Dropdown>
        <DropdownItem onClick={ handleShow } role="button" aria-label="Manual Creation" type="button">
          <EditLine size="1.3em" color="#5a6b7d" />
          Manual Creation
        </DropdownItem>
        <DropdownItem onClick={ handleClickImport } role="button" aria-label="Import from File" type="button">
          <DownloadLine size="1.3em" color="#5a6b7d" />
          Import from File
        </DropdownItem>
      </Dropdown>
      )}

      {/* { showModalImport && <ImportFileCreationModal handleClose={ handleCloseImportFromFile } entity={ entity } /> }
      { showModalCreation && <ManualCreationModal handleClose={ handleClose } entity={ entity } /> } */}
    </Wrapper>
  );
};

export default AddCredentialButton;
